export default function getConfig(name) {
  //Config is defined and injected through webpack build script
  // eslint-disable-next-line no-undef
  return Config[name];
}
